import { memo, useCallback } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import { Formik, Form } from 'formik';
import { VALIDATION_STEP_2 } from 'utils/validations';
import { useDispatch, useSelector } from 'react-redux';
import { fillStep2Data } from 'store/slices/form.slice';
import { nextStep, prevStep } from 'store/slices/global.slice';
import { Step2Content } from './Step2.styled';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { HiOutlineCheck } from 'react-icons/hi';
import BaseTitle from 'components/common/BaseTitle';
import BasePhoneInput from 'components/common/BasePhoneInput';

const Step2 = () => {
  const { phone } = useSelector((state) => state.form);
  const dispatch = useDispatch();
  const onSubmitStep2 = useCallback(
    async (values) => {
      localStorage.setItem("phone", values.phone);
      await dispatch(fillStep2Data(values));
      await dispatch(nextStep());
    },
    [dispatch]
  );
  return (
    <AnimateTop>
      <StepLayout title='What is the best number to call you?'>
        <Formik
          initialValues={{
            phone: phone,
          }}
          validationSchema={VALIDATION_STEP_2}
          onSubmit={onSubmitStep2}
        >
          {/* {({ isValid, dirty }) => ( */}
          <Form>
            <Step2Content>
              <BaseTitle type='subtitle' fw={500}>
                Please enter a direct line. If your number has an extension, you
                can add it at the end of the notes.
              </BaseTitle>
              <BasePhoneInput name='phone' initialValue={phone} />
            </Step2Content>
            <Footer prevArrowClick={() => dispatch(prevStep())}>
              <FooterOkBtn type='submit'>
                OK <HiOutlineCheck />
              </FooterOkBtn>
              <FooterPressText>press Enter ↵</FooterPressText>
            </Footer>
          </Form>
          {/* )} */}
        </Formik>
      </StepLayout>
    </AnimateTop>
  );
};

export default memo(Step2);
